export const RendererKey_AccountMenu_SubHeader = 'account-menu_sub-header';
//# sourceMappingURL=consts.js.map